import _extends from "@babel/runtime/helpers/extends";
import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AlarmBellBoldIcon, ErrorBoldIcon, InfoCircleBoldIcon, SuccessCircleBoldIcon, WarningBoldIcon, XBoldIcon } from '@pattern-library/icon';
var Banner = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Banner, _Component);
  function Banner(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.animateOpening = function () {
      var animationDuration = 300;
      _this.setState({
        isOpening: true
      }, function () {
        window.setTimeout(function () {
          _this.setState({
            isActive: true,
            isOpening: false
          });
        }, animationDuration);
      });
    };
    _this.handleClose = function () {
      var animationDuration = 300;
      var _this$props = _this.props,
        animateClose = _this$props.animateClose,
        onClose = _this$props.onClose;
      var delay = animateClose ? animationDuration : 0;
      _this.setState({
        isClosing: true
      }, function () {
        window.setTimeout(function () {
          onClose();
          _this.setState({
            isActive: false,
            isClosing: false
          });
        }, delay);
      });
    };
    var animateOpen = _this.props.animateOpen;
    _this.state = {
      isActive: !animateOpen,
      isClosing: false,
      message: ''
    };
    return _this;
  }
  var _proto = Banner.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    var _this$props2 = this.props,
      animateOpen = _this$props2.animateOpen,
      animateOpenDelay = _this$props2.animateOpenDelay;
    if (animateOpen) {
      window.setTimeout(function () {
        _this2.animateOpening();
      }, animateOpenDelay);
    }
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      additionalContent = _this$props3.additionalContent,
      customAttrs = _this$props3.customAttrs,
      customClass = _this$props3.customClass,
      inline = _this$props3.inline,
      message = _this$props3.message,
      messageRichText = _this$props3.messageRichText,
      hasCloseButton = _this$props3.hasCloseButton,
      hasIcon = _this$props3.hasIcon;
    var bannerClassNames = classNames('asc-banner', this.typeClass, this.activeClass, customClass, {
      'asc-banner--inline': inline
    });
    var messageClassNames = classNames('asc-banner-message', {
      'asc-banner-message-icon': hasIcon
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "asc-banner-wrapper"
    }, /*#__PURE__*/React.createElement("div", _extends({
      className: bannerClassNames,
      role: this.bannerRole
    }, customAttrs), /*#__PURE__*/React.createElement("div", {
      className: classNames('asc-banner-details', {
        'asc-banner-details--with-close-btn': hasCloseButton
      })
    }, message && /*#__PURE__*/React.createElement("p", {
      className: messageClassNames
    }, hasIcon && this.icon, message), !message && messageRichText && /*#__PURE__*/React.createElement("div", {
      className: messageClassNames
    }, hasIcon && this.icon, messageRichText), additionalContent), hasCloseButton && /*#__PURE__*/React.createElement("button", {
      className: "asc-banner-close-btn",
      type: "button",
      onClick: this.handleClose
    }, /*#__PURE__*/React.createElement(XBoldIcon, {
      size: "xxs",
      color: "current"
    }), /*#__PURE__*/React.createElement("span", {
      className: "asc-acc-hidden"
    }, "Close"))));
  };
  _createClass(Banner, [{
    key: "typeClass",
    get: function get() {
      var type = this.props.type;
      var classByType = {
        caution: 'asc-banner--caution',
        default: 'asc-banner--default',
        notice: 'asc-banner--notice',
        success: 'asc-banner--success',
        warning: 'asc-banner--warning'
      };
      return classByType[type] || '';
    }
  }, {
    key: "activeClass",
    get: function get() {
      var _this$state = this.state,
        isActive = _this$state.isActive,
        isClosing = _this$state.isClosing,
        isOpening = _this$state.isOpening;
      return classNames({
        'asc-banner--active': isActive,
        'asc-banner--opening': isOpening,
        'asc-banner--closing': isClosing
      });
    }
  }, {
    key: "icon",
    get: function get() {
      var _this$props4 = this.props,
        customIcon = _this$props4.customIcon,
        hasIcon = _this$props4.hasIcon,
        type = _this$props4.type;
      if (!hasIcon) {
        return '';
      } else if (customIcon) {
        return customIcon;
      }
      var iconByType = {
        caution: /*#__PURE__*/React.createElement(WarningBoldIcon, {
          color: "warning"
        }),
        default: /*#__PURE__*/React.createElement(InfoCircleBoldIcon, {
          color: "dark-gray"
        }),
        notice: /*#__PURE__*/React.createElement(AlarmBellBoldIcon, {
          color: "dark-gray"
        }),
        success: /*#__PURE__*/React.createElement(SuccessCircleBoldIcon, {
          color: "success"
        }),
        warning: /*#__PURE__*/React.createElement(ErrorBoldIcon, {
          color: "error"
        })
      };
      return iconByType[type] || '';
    }
  }, {
    key: "bannerRole",
    get: function get() {
      var ariaRole = this.props.ariaRole;
      return ariaRole || 'alert';
    }
  }]);
  return Banner;
}(Component);
Banner.propTypes = {
  /**
   * Additional content to render after the message
   */
  additionalContent: PropTypes.element,
  /**
   * Toggle for the opening animation
   */
  animateOpen: PropTypes.bool,
  /**
   * Time to wait before opening the banner; contingent upon `animateOpen` being enabled
   */
  animateOpenDelay: PropTypes.number,
  /**
   * Toggle for the closing animation
   */
  animateClose: PropTypes.bool,
  /**
   * Custom ARIA role for banner element
   */
  ariaRole: PropTypes.string,
  /**
   * Additional props for the banner element
   */
  customAttrs: PropTypes.object,
  /**
   * Additional classes for the banner element
   */
  customClass: PropTypes.string,
  /**
   * Toggle for enabling the close button
   */
  hasCloseButton: PropTypes.bool,
  /**
   * Toggle for showing the icon next to the message
   */
  hasIcon: PropTypes.bool,
  /**
   * Custom icon
   */
  customIcon: PropTypes.element,
  /**
   * Inline banner styles
   */
  inline: PropTypes.bool,
  /**
   * Banner message - either a string or jsx element
   */
  message: PropTypes.node,
  /**
   * Deprecated, will be removed in a future release. Use `message` instead.
   */
  messageRichText: PropTypes.element,
  /**
   * Function to run on banner close
   **/
  onClose: PropTypes.func,
  /**
   * Message type identifier
   */
  type: PropTypes.oneOf(['default', 'success', 'warning', 'caution', 'notice'])
};
Banner.defaultProps = {
  animateClose: true,
  animateOpen: false,
  animateOpenDelay: 0,
  customAttrs: {},
  customClass: '',
  hasCloseButton: true,
  hasIcon: true,
  inline: false,
  onClose: function onClose() {},
  type: 'default'
};
export default Banner;